import { defineStore } from 'pinia'

import type { AssessmentTestStore } from './interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { actions } from './actions'
import { getters } from './getters'

export const useAssessmentTestStore = defineStore('assessment-test', {
  state: (): AssessmentTestStore => ({
    loading: false,
    compiling: false,
    step: null,
    homeStep: null,
    answer: null,
    answers: null,
    question: null,
    questions: [],
    questionNumber: null,
    questionsTotal: null,
    assessmentTitle: null,
    assessmentDescription: null,
    title: null,
    comprehension: false,
    variant: Discipline.Math,
  }),
  actions,
  getters,
})
